import { appRepoList } from '../../Data/AppRepo';
import * as actionTypes from './app-repo-types';

const loadAppRepo = () => {
    return dispatch => {
        console.log("Load AppRepo");

        appRepoList().then( (response) => {
            if(response.hasOwnProperty('errorCode') && response.errorCode === 0) {
                let data = response.data;

                dispatch(loadAppRepoSuccess(data));
            }
        } );
    }
}

const loadAppRepoSuccess = (data) => {
    return {
        type: actionTypes.APP_REPO_LIST,
        payload: {
            data
        }
    }
}

const appRepoActions = {
    loadAppRepo
}

export default appRepoActions;